import { useEffect, useState, useCallback } from "react";

/**
 * Preferenza utente: effetti CRT (scanline + glow verde) attivi o meno.
 * Persistita in localStorage. Applica la classe `mdt-effects-off` sul <html>
 * così il CSS può ridurre selettivamente scanline/glow senza toccare il layout.
 */
const KEY = "mdt_effects_off";

function readInitial() {
  if (typeof window === "undefined") return false;
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

function applyClass(off) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("mdt-effects-off", !!off);
}

export function useMDTEffects() {
  const [off, setOff] = useState(readInitial);

  useEffect(() => { applyClass(off); }, [off]);

  const toggle = useCallback(() => {
    setOff((prev) => {
      const next = !prev;
      try { localStorage.setItem(KEY, next ? "1" : "0"); } catch { /* ignore */ }
      return next;
    });
  }, []);

  return { effectsOn: !off, toggle };
}

// Applica la preferenza salvata subito al primo import (prima del render dell'app)
if (typeof window !== "undefined") applyClass(readInitial());
